import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AttachmentDTO} from '../../../../../services/api/api';
import {AttachmentService} from '../../../../../services/attachment.service';
import {OpenModalService} from '../../../../../services/gui/modal/open-modal.service';

@Component({
  selector: 'sb-comp-attachment-card-entry',
  templateUrl: './attachment-card-entry.component.html',
  styleUrls: ['./attachment-card-entry.component.scss'],
  standalone: false,
})
export class AttachmentCardEntryComponent implements OnInit {
  @Input() attachment: AttachmentDTO;
  @Output() attachmentSelected: EventEmitter<AttachmentDTO> = new EventEmitter<AttachmentDTO>();

  @Output() dragendEmitter: EventEmitter<any>;
  @Output() dragstartEmitter: EventEmitter<{ event: DragEvent; item: AttachmentDTO }>;
  hover: boolean;

  animationOptions: any = {
    autoplay: true,
    loop: true,
  };

  constructor(
    public attachmentService: AttachmentService,
    public openModal: OpenModalService
  ) {
    this.dragendEmitter = new EventEmitter<any>();
    this.dragstartEmitter = new EventEmitter<{ event: DragEvent; item: AttachmentDTO }>();
  }

  ngOnInit(): void {}
}
